import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Maximize2, X } from 'lucide-react';

const WindowsContext = createContext(null);

export const WindowsProvider = ({ children }) => {
  const [minimized, setMinimized] = useState([]);
  const [restoring, setRestoring] = useState(null);

  const minimizeWindow = useCallback((win) => {
    setMinimized(prev => [...prev.filter(w => w.key !== win.key), win]);
  }, []);
  const restoreWindow = useCallback((win) => {
    setRestoring(win);
    setMinimized(prev => prev.filter(w => w.key !== win.key));
  }, []);
  const closeWindow = useCallback((key) => {
    setMinimized(prev => prev.filter(w => w.key !== key));
  }, []);
  const clearRestoring = useCallback(() => setRestoring(null), []);

  return (
    <WindowsContext.Provider value={{ minimized, restoring, minimizeWindow, restoreWindow, closeWindow, clearRestoring }}>
      {children}
    </WindowsContext.Provider>
  );
};

const noop = () => {};
export const useWindows = () => useContext(WindowsContext) || {
  minimized: [], restoring: null,
  minimizeWindow: noop, restoreWindow: noop, closeWindow: noop, clearRestoring: noop,
};

export const WindowsTaskbar = () => {
  const { minimized, restoreWindow, closeWindow } = useWindows();
  const navigate = useNavigate();
  const location = useLocation();
  if (!minimized.length) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[1200] flex flex-col items-end gap-2" data-testid="windows-taskbar">
      {minimized.map(w => (
        <div key={w.key} className="flex items-center gap-1 bg-[#1c1c1c] text-[#f8f6f1] rounded-full pl-4 pr-1.5 py-1.5 shadow-lg border border-black/20">
          <button
            type="button"
            onClick={() => { if (w.route && location.pathname !== w.route) navigate(w.route); restoreWindow(w); }}
            className="flex items-center gap-2 text-[12px] hover:opacity-80 transition-opacity"
            title="Restaurar ventana"
            data-testid={`taskbar-restore-${w.key}`}
          >
            <Maximize2 size={12}/>
            <span className="max-w-[200px] truncate">{w.title}</span>
            {w.subtitle && <span className="text-[10px] text-[#a8a397] uppercase tracking-wide">{w.subtitle}</span>}
          </button>
          <button
            type="button"
            onClick={() => closeWindow(w.key)}
            className="w-6 h-6 rounded-full hover:bg-white/15 flex items-center justify-center transition-colors"
            aria-label="Descartar ventana"
            data-testid={`taskbar-close-${w.key}`}
          >
            <X size={12}/>
          </button>
        </div>
      ))}
    </div>
  );
};
